export const SUBJ_TEST_REQUEST = 'SUBJ_TEST_REQUEST';
export const SUBJ_TEST_RECEIVE = 'SUBJ_TEST_RECEIVE';
export const SUBJ_TEST_ERROR = 'SUBJ_TEST_ERROR';



// WEBPACK FOOTER //
// ./src/store/subjectTest/actionTypes.js